<style>
  .fiesta {
    text-align: center;
    margin-top: 55px;
    padding: 0.5rem 1rem;
    max-width: 100vw;
  }
</style>

<template>
  <div class="fiesta">
   <ImageGallery class="image-gallery" :image-list="novias">
    </ImageGallery>
  </div>
</template>

<script>
import ImageGallery from '@/components/ImageGallery.vue'
import { fiesta } from '@/fiesta.js'

export default {
  name: 'fiesta',
  components: {
    ImageGallery
  },
  data () {
    return {
      novias: fiesta()
    }
  }
}
</script>
